<kendo-dialog [title]="referenceDataLabels.AffordabilityResult | localizeLabel" (close)="close()" [height]="350"
              [width]="500">
  <p class="fs-16" [innerHTML]="referenceDataLabels.AffordabilityWarningParagraph1 | localizeLabel"></p>
  <br/>
  <p class="fs-14" [innerHTML]="referenceDataLabels.AffordabilityWarningParagraph2 | localizeLabel"></p>
  <ul class="list">
    <li *ngFor="let validationError of data">
      <div
         [innerHtml]="validationError.name | localizeErrorMessage:validationError.code:validationError.args">
      </div>
    </li>
  </ul>
  <p class="fs-14" [innerHTML]="referenceDataLabels.AffordabilityWarningParagraph3 | localizeLabel"></p>
</kendo-dialog>
